<template>
  <div>
    <table class="table table-bordered align-middle">
      <thead class="table-light">
        <tr>
          <th
            class="col"
            v-for="a in column"
            :key="a.dataIndex"
            :style="{ width: a.width ? a.width : '' }"
            scope="col"
          >
            {{ a.title }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(a, index) in displayedPosts" :key="index">
          <td v-for="s in column" :key="s" scope="col">
            <span v-if="i18nIncludesTimeDate(s.title)">{{a[s.dataIndex] && moment(a[s.dataIndex]).tz($tz).format("YYYY-MM-DD HH:mm:ss")  || this.$t('page.no')}}</span>
            <span v-else-if="s.title == $t('page.work-order.name') || s.title == '设备名称'" class="link-primary" style="cursor: pointer;" @click="goDetail(a)" >{{ a[s.dataIndex] }}</span>
            <span v-else-if="isAttributes && s.dataIndex === 'name'">{{ $t(a[s.dataIndex]) }}</span>
            <span v-else-if="isAttributes && s.dataIndex === 'unit'">{{ (a[s.dataIndex] === '无' || !a[s.dataIndex]) ? $t('page.no') : a[s.dataIndex] }}</span>
            <span v-else>{{
              {
                string: $t("also.CharacterString"),
                number: $t("also.integer"),
                float: $t("also.double-precisionNumber"),
                boolean: $t("also.boolean"),
              }[a[s.dataIndex]] || a[s.dataIndex] || this.$t('page.no')
            }}</span>
          </td>
        </tr>
      </tbody>
    </table>
    <div
      v-if="totalCount != 0"
      class="d-flex justify-content-end mt-3"
    >
      <div class="pagination-wrap hstack gap-2">
        <a
          class="page-item pagination-prev"
          href="javascript:void(0);"
          @click="page != 1 && page--"
        >
          <i class="bx bx-chevron-left"></i>
        </a>

<!--        <ul class="pagination listjs-pagination mb-0">-->
<!--          <li-->
<!--            v-for="(pageNumber, index) in pages"-->
<!--            :class="{-->
<!--              active: pageNumber == page,-->
<!--              disabled: pageNumber == '...',-->
<!--            }"-->
<!--            :key="index"-->
<!--            @click="page = pageNumber"-->
<!--          >-->
<!--            <a class="page" href="javascript:void(0);">{{ pageNumber }}</a>-->
<!--          </li>-->
<!--        </ul>-->

        <ul class="pagination listjs-pagination mb-0">
          <li v-show="page != 1" @click="page = pages[0]">
            <a class="page" href="javascript:;">{{ pages[0] }}</a>
          </li>
          <li v-show="page != 1 && page != 2">
            <a class="page" href="javascript:;">...</a>
          </li>
          <li
            v-for="(pageNumber, index) in pages.slice(page - 1, page + 3)"
            :key="index"
            @click="page = pageNumber"
            :class="{
            active: pageNumber == page,
            disabled: pageNumber == '...',
          }"
          >
            <a class="page" href="javascript:;">{{ pageNumber }}</a>
          </li>
          <li
            v-show="
            page + 3 < pages[pages.length - 2] &&
            page * perPage <= totalCount
          "
          >
            <a class="page" href="javascript:;">...</a>
          </li>
          <li
            v-show="
            page + 3 < pages[pages.length - 1] &&
            page * perPage <= totalCount
          "
            @click="page = pages[pages.length - 1]"
          >
            <a class="page" href="javascript:;">{{ pages[pages.length - 1] }}</a>
          </li>
        </ul>


        <a
          class="page-item pagination-next"
          href="javascript:void(0);"
          @click="page < pages.length && page++"
        >
          <i class="bx bx-chevron-right"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import 'moment-timezone';
import { getLanguage } from "@/i18n";
export default {
  emits:["getDetailId", "pageDataLoaded"],
  props: {
    tableData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    column: {
      type: Array,
      default: () => {
        return [];
      },
    },
    detailRouter: {
      type: String,
      default: "/asset?asset_id"
    },
    // 是否通过api分页
    paginateByApi: {
      type: Boolean,
      default: false,
    },
    // 分页函数
    paginateFunc: {
      type: Function,
      default: () => {},
    },
    isAttributes: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      page: 1,
      perPage: 10,
      pages: [],
      // 分页数据
      pageData: [],
      count: null,
    };
  },
  computed: {
    displayedPosts() {
      if (this.paginateByApi) {
        return this.pageData;
      }
      return this.paginate(this.tableData);
    },
    totalCount() {
      if (this.paginateByApi) {
        return this.count;
      }
      return this.tableData.length;
    },
  },
  watch: {
    tableData() {
      if (this.paginateByApi) {
        return;
      }
      this.page = 1;
      this.perPage = 10;
      this.pages = [];
      this.setPages();
    },
    page(val) {
      if (!this.paginateByApi) {
        return;
      }
      if (val) {
        this.getList();
      }
    },
  },
  mounted() {
    if (!this.paginateByApi) {
      this.setPages();
    } else {
      // 获取第一页
      this.getFirstPage();
    }
  },
  methods: {
    moment,
    goDetail(data){
      this.$router.push(this.detailRouter + '='+data.id)
      this.$emit("getDetailId", data);
      
    },
    setPages() {
      this.pages = [];
      let numberOfPages = Math.ceil(this.totalCount / this.perPage);
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    paginate(data) {
      let page = this.page;
      let perPage = this.perPage;
      let from = page * perPage - perPage;
      let to = page * perPage;
      return data.slice(from, to);
    },
    // 获取列表
    getList() {
      this.paginateFunc({
        page: this.page,
        page_size: this.perPage,
      }).then((res) => {
        this.pageData = res.payload.results;
        this.count = res.payload.count;
        this.setPages()
        this.$emit("pageDataLoaded", this.count);
      });
    },
    // 获取第一页
    getFirstPage() {
      this.page = 1;
      this.getList();
    },
    //是否包含时间，日期
    i18nIncludesTimeDate(title){
      const lang = getLanguage()
      if( lang == 'ch' ){ /* 中文 */
        return title.includes('时间')  || title.includes('日期')
      }else{
        return title.toLowerCase().includes('time') || title.toLowerCase().includes('date')
      }
    }

  },
};
</script>

<style></style>
